export enum DataMoverType {
	SINGLE = 'SINGLE',
	MULTIPLE = 'MULTIPLE',
}
